/**
 * sw-update-policy — décisions pures de la mise à jour du service worker
 * (séparées de sw-update.ts qui importe le module virtuel vite-plugin-pwa,
 * non résolvable sous vitest). Voir sw-update.ts pour le contexte.
 */

export const SW_CHECK_INTERVAL_MS = 10 * 60 * 1000;
export const IDLE_BEFORE_RELOAD_MS = 3 * 60 * 1000;
export const RETRY_RELOAD_MS = 60 * 1000;

export type IdleProbe = {
  now: () => number;
  lastInteractionAt: () => number;
  hasOpenDialog: () => boolean;
};

/** Décision pure : peut-on recharger sans gêner personne ? */
export function canReloadNow(p: IdleProbe): boolean {
  if (p.hasOpenDialog()) return false;
  return p.now() - p.lastInteractionAt() >= IDLE_BEFORE_RELOAD_MS;
}

/** Suivi des interactions (tap, clic, touche) — pas de reload à chaud. */
export function createInteractionTracker(doc: Document = document) {
  let last = Date.now();
  const mark = () => {
    last = Date.now();
  };
  for (const ev of ['pointerdown', 'touchstart', 'keydown', 'wheel'] as const) {
    doc.addEventListener(ev, mark, { capture: true, passive: true });
  }
  return { lastInteractionAt: () => last };
}
